import { Button } from "@oc-labs/wt-storybook";
import ModalV2 from "../../../../components/ModalV2";
import useModal from "../../../../hooks/useModal";
import { useEffect, useState } from "react";
import useRwas from "../../../../hooks/useRwas";
import useCompany from "../../../../hooks/useCompany";
import toast from "react-hot-toast";
import InputParamField from "./InputParamField";

export default function RWAEditParamModal({ rwa, reloadRwa }) {
  const { activeCompany: company } = useCompany();
  const { modal, close } = useModal('rwa-edit-param-modal');
  const [newValue, setNewValue] = useState('');

  useEffect(() => {
    const paramKey = modal?.props
    const paramValue = rwa?.[paramKey] || rwa?.data?.[paramKey]?.value;
    setNewValue(paramValue || '');
  }, [modal, rwa]);

  const paramKey = modal?.props
  const paramType = rwa?.data?.[paramKey]?.fieldType || 'text';

  const { updateRwa } = useRwas();
  const handleUpdateRWA = async () => {
    const isProp = rwa?.[paramKey] !== undefined;
    console.log(`Updating RWA ${isProp ? 'prop' : 'param'} with new value:`, newValue);

    const basePayload = {
      name: rwa?.name,
      type: rwa?.type,
    };

    if (isProp) {
      await updateRwa(company.id, rwa?.id, {
        ...basePayload,
        [paramKey]: newValue
      });
    } else {
      await updateRwa(company.id, rwa?.id, {
        ...basePayload,
        params: {
          [paramKey]: {
            type: paramType,
            value: newValue
          }
        }
      });
    }

    toast.success(`Updated ${paramKey} for ${rwa?.name}`);
    reloadRwa();
    close();
  }

  return (<ModalV2 name={'rwa-edit-param-modal'} className={`min-w-[500px]`} title={`Edit ${paramKey} for ${rwa?.name}`}>
    <InputParamField 
      type={paramType}
      keyName={paramKey}
      value={newValue}
      variant="modal"
      onChange={(newValue) => setNewValue(newValue)}
    />

    <Button
      className="mt-4"
      onClick={handleUpdateRWA}
    >
      Save
    </Button>
  </ModalV2>)
}